import { Button } from 'components/Form'
import ModalWrapper from 'components/ModalWrapper'
import React, { } from 'react'
import { I18n } from 'react-redux-i18n'
import './styles.scss'

const SyncErrorModal = (props) => {
  const { isOpen, toggle, onClick, data } = props

  return (
    <ModalWrapper
      id={'modalSyncError'}
      header=' '
      body={
        <div className='sync-error-wrapper'>
          <img className='icon-remove' src='img/icons/icon-warning-red.svg' alt='remove' />
          <h1>{I18n.t('channels_error_sync_title')}</h1>
          <legend dangerouslySetInnerHTML={{ __html: I18n.t('channels_error_sync_legend').replace('xxx@xxx', data?.name) }} />
          <Button secondary value={`${I18n.t('dashboard_to-access')}`} onClick={onClick} />
        </div>
      }
      isOpen={isOpen}
      toggle={toggle}
      showClose={true}
    />
  )
}

export default SyncErrorModal